<script setup lang="ts">
import Footer from "@/components/landing/shared/Footer.vue";
import SimpleNavbar from "@/components/landing/shared/SimpleNavbar.vue";
import AppConfig from "@/layout/common/AppConfig.vue";

const { footer } = defineProps({
  footer: {
    type: Boolean,
    default: true,
  },
});
</script>

<template>
  <div
    class="bg-surface-50 dark:bg-surface-950 w-full min-h-screen overflow-hidden"
  >
    <SimpleNavbar />
    <router-view />
    <Footer v-if="footer" />
    <AppConfig location="landing" />
  </div>
</template>
